import { MediaProjectResponse } from "pages/media/types";
import SpeakerView from "../SpeakerView";

export function ProjectSettingsFormContacts<T>(
  props: Readonly<{
    value: T | undefined;
    initialValue: T | undefined;
    onChange: (value: T) => void;
    /** Notifies the parent whether the picked contact is voice-only (no face). */
    onIsVoiceOnlyChange?: (isVoiceOnly: boolean) => void;
    items: {
      value: string;
      name: string;
      description: string;
    }[];
    project?: MediaProjectResponse;
    isSetup?: boolean;
    isEdit?: boolean;
  }>
) {
  return (
    <SpeakerView
      initialVoiceOnly={false}
      showMoreFields={false}
      project={props.project ?? null}
      onContactChange={(value, isVoiceOnly) => {
        props.onChange(value as T);
        props.onIsVoiceOnlyChange?.(isVoiceOnly);
      }}
      showNavigation={false}
      showHeader={false}
      itemsPerSlide={2}
    />
  );
}
